import { Box, Container, Flex, Text, Divider, SimpleGrid, Input, FormControl, FormLabel, Select, ButtonGroup, Button, FormErrorMessage } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LoadingScreen from "components/loading-screen";
import Layout from "scenes/layouts";
import { useNavigate, useParams } from "react-router-dom";
import { Field, Formik } from "formik";
import LogosNotification from "utils/notification-utils";
import VoucherService from "../../services/vouchers/voucher-service";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import ProgramService from "../../services/programs/program-service";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

const today = new Date();

const formInitialValue = {
    name: '',
    voucherCode: '',
    isPercentage: true,
    value: 0,
    isCanExpire: true,
    expiryDate: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 16, 59, 59),
    isForAllProgram: true,
    programId: '',
    isHaveRestriction: false,
    restrictionProgramId: '',
    isActive: false
};

const NewVoucher = (): ReactElement => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [isSaving, setSaving] = useState<boolean>(false);
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [programs, setPrograms] = useState<any>([]);
    const [time, setTime] = useState('23:59');;

    useEffect(() => {
        setLoading(true);

        ProgramService.GetAllProgram().then((programRes: any) => {
            setPrograms(programRes.result);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        VoucherService.Create(
            values.name,
            values.voucherCode,
            values.isPercentage,
            values.isPercentage ? values.value / 100 : values.value,
            values.isCanExpire,
            values.expiryDate,
            time,
            values.isForAllProgram,
            values.programId,
            values.isHaveRestriction,
            values.restrictionProgramId,
            values.isActive
            //dateOfBirth: new Date(values.dateOfBirthYear, values.dateOfBirthMonth, values.dateOfBirthDay)
        ).then((res: any) => {
            LogosNotification.Success("Voucher berhasil diperbaharui.");
            navigate('/vouchers');
        }).finally(() => {
            setSaving(false);
        });
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={'3xl'} fontWeight={"bold"}>Buat Voucher Baru</Text>
                    </Flex>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, values, setFieldValue }) => (
                                <form onSubmit={handleSubmit} noValidate={true}>
                                    <Box rounded={'lg'} fontSize={'sm'} border={'1px solid'} borderColor={'blackAlpha.400'}>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                                    <FormLabel htmlFor='name'>Nama Voucher</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='name'
                                                        placeholder='Nama Voucher'
                                                        name={'name'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nama Voucher wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.name}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} py={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.voucherCode && touched.voucherCode)}>
                                                    <FormLabel htmlFor='voucherCode'>Kode Voucher</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='voucherCode'
                                                        placeholder='Kode Voucher'
                                                        name={'voucherCode'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Kode Voucher wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.voucherCode}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.isPercentage && touched.isPercentage)}>
                                                    <FormLabel htmlFor='isPercentage'>Apakah dalam Persentase?</FormLabel>
                                                    <Field
                                                        type="checkbox"
                                                        id='isPercentage'
                                                        name={'isPercentage'}
                                                        checked={values.isPercentage}
                                                        style={{ width: '22px', height: '22px' }}
                                                    >
                                                    </Field>
                                                    <FormErrorMessage>{errors.isPercentage}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pb={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.value && touched.value)}>
                                                    <FormLabel htmlFor='value'>Nilai Diskon ({values.isPercentage ? "%" : "Rupiah"})</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='value'
                                                        placeholder='Nilai Diskon'
                                                        name={'value'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nilai Diskon wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.value}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <Box>
                                                    <FormControl isRequired isInvalid={!!(errors.isCanExpire && touched.isCanExpire)}>
                                                        <FormLabel htmlFor='isCanExpire'>Ada Tanggal Kadarluasa?</FormLabel>
                                                        <Field
                                                            type="checkbox"
                                                            id='isCanExpire'
                                                            name={'isCanExpire'}
                                                            checked={values.isCanExpire}
                                                            style={{ width: '22px', height: '22px' }}
                                                        >
                                                        </Field>
                                                        <FormErrorMessage>{errors.isCanExpire}</FormErrorMessage>
                                                    </FormControl>
                                                    {
                                                        values.isCanExpire &&
                                                        <Box>
                                                            <FormControl isRequired isInvalid={!!(errors.expiryDate && touched.expiryDate)} mt={1}>
                                                                <FormLabel htmlFor='value'>Tanggal Kadarluasa</FormLabel>
                                                                <SingleDatepicker
                                                                    id='expiryDate'
                                                                    name='expiryDate'
                                                                    date={values.expiryDate}
                                                                    onDateChange={(date: Date) => {
                                                                        setFieldValue("expiryDate", date);
                                                                    }}
                                                                />
                                                                <FormErrorMessage>{errors.expiryDate}</FormErrorMessage>
                                                            </FormControl>
                                                            <FormControl mt={2}>
                                                                <TimePicker onChange={(time: any) => setTime(time)} value={time} format={"HH:mm"} />
                                                            </FormControl>
                                                        </Box>
                                                    }
                                                </Box>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <Box>
                                                    <FormControl isRequired isInvalid={!!(errors.isForAllProgram && touched.isForAllProgram)}>
                                                        <FormLabel htmlFor='isCanExpire'>Semua Program?</FormLabel>
                                                        <Field
                                                            type="checkbox"
                                                            id='isForAllProgram'
                                                            name={'isForAllProgram'}
                                                            checked={values.isForAllProgram}
                                                            style={{ width: '22px', height: '22px' }}
                                                        >
                                                        </Field>
                                                        <FormErrorMessage>{errors.isForAllProgram}</FormErrorMessage>
                                                    </FormControl>
                                                    {
                                                        values.isForAllProgram && <FormControl></FormControl>
                                                    }
                                                    {
                                                        !values.isForAllProgram &&
                                                        <FormControl isRequired isInvalid={!!(errors.programId && touched.programId)} mt={1}>
                                                            <FormLabel htmlFor='value'>Program</FormLabel>
                                                            <Field as={Select} id='programId' placeholder='Pilih Program' name={'programId'}
                                                                validate={(value: any) => {
                                                                    let error;
                                                                    if (!value)
                                                                        error = "Silahkan pilih Program";
                                                                    return error;
                                                                }}>
                                                                {
                                                                    programs.map((program: any) => {
                                                                        return <option value={program.id}>{program.name}</option>;
                                                                    })
                                                                }
                                                            </Field>
                                                            <FormErrorMessage>{errors.programId}</FormErrorMessage>
                                                        </FormControl>
                                                    }

                                                </Box>

                                                <Box>
                                                    <FormControl isRequired isInvalid={!!(errors.isHaveRestriction && touched.isHaveRestriction)}>
                                                        <FormLabel htmlFor='isCanExpire'>Bisa digunakan Jika sudah punya Program?</FormLabel>
                                                        <Field
                                                            type="checkbox"
                                                            id='isHaveRestriction'
                                                            name={'isHaveRestriction'}
                                                            checked={values.isHaveRestriction}
                                                            style={{ width: '22px', height: '22px' }}
                                                        >
                                                        </Field>
                                                        <FormErrorMessage>{errors.isHaveRestriction}</FormErrorMessage>
                                                    </FormControl>
                                                    {
                                                        !values.isHaveRestriction && <FormControl></FormControl>
                                                    }
                                                    {
                                                        values.isHaveRestriction &&
                                                        <FormControl isRequired isInvalid={!!(errors.restrictionProgramId && touched.restrictionProgramId)} mt={1}>
                                                            <FormLabel htmlFor='value'>Jika punya Program</FormLabel>
                                                            <Field as={Select} id='restrictionProgramId' placeholder='Pilih Program' name={'restrictionProgramId'}
                                                                validate={(value: any) => {
                                                                    let error;
                                                                    if (!value)
                                                                        error = "Silahkan pilih Program";
                                                                    return error;
                                                                }}>
                                                                {
                                                                    programs.map((program: any) => {
                                                                        return <option value={program.id}>{program.name}</option>;
                                                                    })
                                                                }
                                                            </Field>
                                                            <FormErrorMessage>{errors.restrictionProgramId}</FormErrorMessage>
                                                        </FormControl>
                                                    }

                                                </Box>

                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.isActive && touched.isActive)}>
                                                    <FormLabel htmlFor='isActive'>Aktif?</FormLabel>
                                                    <Field
                                                        type="checkbox"
                                                        id='isActive'
                                                        name={'isActive'}
                                                        checked={values.isActive}
                                                        style={{ width: '22px', height: '22px' }}
                                                    >
                                                    </Field>
                                                    <FormErrorMessage>{errors.isActive}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />
                                        <Box px={8} py={8}>
                                            <ButtonGroup gap={2}>
                                                <Button type={'submit'} isLoading={isSaving}>Simpan</Button>
                                                <Button variant={'outline'} onClick={() => { navigate('/vouchers') }}>Kembali</Button>
                                            </ButtonGroup>
                                        </Box>
                                    </Box>
                                </form>
                            )
                        }
                    </Formik>
                </Box>
            </Container>
        </Layout >
    );
};

export default NewVoucher;